import { analyticsService } from "Apis";

export const listQuickInsightResults = async (projectId: number) => {
  const quickInsightResults =
    await analyticsService.analyticsServiceListQuickInsights({
      projectId,
    });
  return quickInsightResults.results || [];
};
